import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { APIURL } from "../../../Global";
import Pagination from "react-js-pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import "./pagination.css";
import { useTranslation } from 'react-i18next';
import { formatDateString } from '../../../utils/dateUtils';

function RegisteredHospitals() {
  const { t } = useTranslation();
  const { state } = useLocation()
  const [selected, setSelected] = useState(state && state.approve ? "approved" : "pending")
  const [loading, setLoading] = useState(false);
  const [pending, setPending] = useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState("");
  const [nameSearch, setNameSearch] = useState("")
  const [locSearch, setLocSearch] = useState("")
  const [idSearch, setIdSearch] = useState("")
  const [typeSearch, setTypeSearch] = useState("")
  const [perPage,] = useState(20);
  const navigate = useNavigate();


  useEffect(() => {
    if (selected !== "expired") {

      setLoading(true)
      const tokenString = sessionStorage.getItem("usertoken");

      let v2 = tokenString.replace(
        /["]+/g,
        ""
      );
      axios.get(`${APIURL}/api/v1/staff/hospital-approve/?sort=${sort}&hospital_name=${nameSearch}&hospital_id=${idSearch}&sp_type=${typeSearch}&location=${locSearch}&${selected === "approved" ? "status=approved" : selected === "rejected" ? "status=rejected" : ""}`, {
        headers: { Authorization: "Token " + v2 },
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const data = res.data.hospitals
            setPending(data)
          }
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [selected, sort, nameSearch, locSearch, typeSearch, idSearch])

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const indexLast = currentPage * perPage;
  const indexFirst = indexLast - perPage;
  const current = pending.slice(indexFirst, indexLast);
  const total = pending.length;

  const pageNumbers = []
  for (let i = 0; i <= Math.ceil(total / perPage); i++) {
    pageNumbers.push(i)
  }
  const totalPages = pageNumbers.length;

  // Helper function to clean name from suffixes
  const cleanName = (name) => {
    if (!name) return '';
    // Remove -deleted<number> and -rejected<number> patterns
    return name.replace(/-deleted\d+$/, '').replace(/-rejected\d+$/, '');
  };

  let display = current.length > 0 ? current.map((data, index) => {
    let id = data.id

    return (

      <>
        <div className="row " key={data.id}

          onClick={() => { if (data.status !== "rejected") { navigate(`/hospital-details/${id}`) } }}
          style={{
            fontSize: "13px", cursor: "pointer", textAlign: "left", borderLeft: "0.4px solid #5f5e5e7a", borderBottom: "0.4px solid #5f5e5e7a", borderRight: "0.4px solid #5f5e5e7a",
            boxShadow: " 2px 2px 7px rgb(0 0 0 / 30%)", marginBottom: "0.5%"
          }}>
          <div style={{ backgroundColor: "#40E0D036", padding: "1%", borderRight: "0.4px solid #5f5e5e7a", fontSize: "10px", fontWeight: "bold" }} className="col-2">{data.vendor_id}</div>
          <div style={{ backgroundColor: "#40E0D036", padding: "1%", borderRight: "0.4px solid #5f5e5e7a", whiteSpace: "nowrap", overflow: "hidden", textTransform: "capitalize", textOverflow: "ellipsis" }} className="col-3">{cleanName(data.name)}</div>
          {/* {selected === "approved" && <div style={{ padding: "1%" }} className="col-1">{data.patients_count}</div>} */}

          <div style={{ padding: "1%" }} className="col-3">{t(`professionalsList.${data.sp_type}`, { defaultValue: data.sp_type })}</div>

          <div style={{ padding: "1%" }} className="col-2">{formatDateString(data.date_of_joining)}</div>
          <div style={{ padding: "1%", whiteSpace: "nowrap", overflow: "hidden", textTransform: "capitalize", textOverflow: "ellipsis" }} className="col-2" >{data.location}</div></div>




      </>)
  }) : null

  return (

    <div className='row ' style={{ marginTop: "1%", width: "100%", minHeight: "71vh" }}>



      <div className="col-3">
        <h5 className="" style={{ color: "#5f5e5f", paddingLeft: "2%" }}>{t('registeredHospitals.vendors')} </h5>
        <div className="det-div " style={{ padding: "1%" }}>


          <button className={selected === "pending" ? "patientRecbutton1" : "patientRecbutton"}
            style={{ width: "100%", }}
            onClick={() => {
              setSelected("pending"); setCurrentPage(1)
            }}
          >
            &nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="currentColor" fillRule="evenodd" d="M20 4a3 3 0 0 0-3 3h-3a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h12v-2H14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h3a1 1 0 0 1 1 1v15h2V10a3 3 0 0 0-3-3h-3a3 3 0 0 0-3-3h-8Zm-1 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V7Zm4 12v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Zm4 9a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6.789a7 7 0 0 1-3.117 5.824l-3.328 2.22a1 1 0 0 1-1.11 0l-3.328-2.22A7 7 0 0 1 27 34.79V28Zm2 1v5.789a5 5 0 0 0 2.227 4.16L34 40.8l2.773-1.85A5 5 0 0 0 39 34.79V29H29Zm4.707 7.707l4-4l-1.414-1.414L33 34.586l-1.293-1.293l-1.414 1.414l2 2a1 1 0 0 0 1.414 0Z" clipRule="evenodd" /></svg>
            &nbsp;
            {t('registeredHospitals.pending')}

          </button>
          <button className={selected === "approved" ? "patientRecbutton1" : "patientRecbutton"}
            style={{ width: "100%" }}
            onClick={() => {
              setSelected("approved"); setCurrentPage(1)
            }}
          >
            &nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 9a2 2 0 1 0 0 4a2 2 0 0 0 0-4Zm-4 8.5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z" /><path fill="currentColor" fillRule="evenodd" d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V8.198a1.75 1.75 0 0 0-.328-1.02L16.408 2.98a1.75 1.75 0 0 0-1.421-.73H7ZM5.75 5c0-.69.56-1.25 1.25-1.25h7.25v4.397c0 .414.336.75.75.75h3.25V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25V5Z" clipRule="evenodd" /></svg>
            &nbsp;
            {t('registeredHospitals.approved')}

          </button>
          <button className={selected === "rejected" ? "patientRecbutton1" : "patientRecbutton"}
            style={{ width: "100%", }}
            onClick={() => {
              setSelected("rejected"); setCurrentPage(1)
            }}
          >
            &nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 9a2 2 0 1 0 0 4a2 2 0 0 0 0-4Zm-4 8.5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z" /><path fill="currentColor" fillRule="evenodd" d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V8.198a1.75 1.75 0 0 0-.328-1.02L16.408 2.98a1.75 1.75 0 0 0-1.421-.73H7ZM5.75 5c0-.69.56-1.25 1.25-1.25h7.25v4.397c0 .414.336.75.75.75h3.25V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25V5Z" clipRule="evenodd" /></svg>
            &nbsp;
            {t('registeredHospitals.rejected')}

          </button>


        </div>
      </div>



      <div className="col-9" style={{ minHeight: "71vh" }}>
        <div className="">

          <div className="container" style={{}}>

            {selected !== "expired" && <div className='row'>


              <div className="col-11">
                <div className="search-div row">
                  <div className="col-3" >

                    <input

                      type="text"
                      className="search-clinics"
                      placeholder={t('registeredHospitals.searchClinic')}
                      value={nameSearch}
                      onChange={(e) => { setCurrentPage(1); setNameSearch(e.target.value) }}
                    // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
                    />


                  </div>
                  <div className="col-3" >

                    <input

                      type="text"
                      className="search-clinics"
                      placeholder={t('registeredHospitals.searchID')}
                      value={idSearch}
                      onChange={(e) => { setCurrentPage(1); setIdSearch(e.target.value) }}
                    // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
                    />


                  </div>
                  <div className="col-3" >

                    <input

                      type="text"
                      className="search-clinics"
                      placeholder={t('registeredHospitals.searchLocation')}
                      value={locSearch}
                      onChange={(e) => { setCurrentPage(1); setLocSearch(e.target.value) }}
                    // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
                    />


                  </div>
                  <div className="col-3" >
                    <select
                      name='allergytype'
                      className="search-clinics"
                      type="text"
                      value={typeSearch}
                      onChange={(e) => { setCurrentPage(1); setTypeSearch(e.target.value) }}
                    >
                      <option value="">{t('registeredHospitals.all')}</option>
                      <option value="Hospital">{t('professionalsList.Hospital')}</option>
                      <option value="Clinic">{t('professionalsList.Clinic')}</option>
                      <option value="Pharmacy">{t('professionalsList.Pharmacy')}</option>
                      <option value="Laboratory">{t('professionalsList.Laboratory')}</option>
                      <option value="Single Doctor">{t('professionalsList.Single Doctor')}</option>
                      <option value="Single Nurse">{t('professionalsList.Single Nurse')}</option>
                      <option value="Therapists">{t('professionalsList.Therapists')}</option>
                      <option value="Neurodevelopmental Specialists">{t('professionalsList.Neurodevelopmental Specialists')}</option>
                      <option value="Dentists">{t('professionalsList.Dentists')}</option>
                      <option value="Patient Assistants">{t('professionalsList.Patient Assistants')}</option>
                      <option value="Odontologists">{t('professionalsList.Odontologists')}</option>
                      <option value="Psychologists">{t('professionalsList.Psychologists')}</option>
                      <option value="Nutritionists">{t('professionalsList.Nutritionists')}</option>
                      <option value="Physiotherapists">{t('professionalsList.Physiotherapists')}</option>
                      <option value="Respiratory Therapists">{t('professionalsList.Respiratory Therapists')}</option>
                      <option value="Electrocardiography">{t('professionalsList.Electrocardiography')}</option>
                      <option value="Speech Therapists">{t('professionalsList.Speech Therapists')}</option>

                    </select>



                  </div>
                </div>
              </div>

              <div className="col-1">
                <button className="" onClick={() => { sort === "" ? setSort("asc") : setSort("") }} style={{ boxShadow: "3px 5px 10px #5f5e5f", height: "35px", padding: "2%", fontSize: "small", color: "white", backgroundColor: "#5f5e5f", border: "none", borderRadius: "5px" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8 16H4l6 6V2H8zm6-11v17h2V8h4l-6-6z" /></svg>
                </button>
              </div>
              {/* <div className="col-2">
              <button className="" onClick={() => navigate("/Deregistered_splist")} style={{ boxShadow: "3px 5px 10px rgba(0,0,0,0.2)", height: "40px", fontSize: "small",  color: "white", backgroundColor: "#272244", border: "none",borderRadius:"5px" }}>
              Deregistered Clinics  <i class="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            </div> */}
            </div>}
          </div><br />

          <div className="" style={{ margin: "auto" }}>
            <div className="container" style={{}}>
              <div className="test-reports-display-list">
                {display ? <>
                  <div className="row " style={{ backgroundColor: "#01C9C9", color: "white", textAlign: "left", padding: "1%", borderRadius: "5px 5px 0px 0px", boxShadow: "2px 2px 7px rgb(0 0 0 / 30%)", marginBottom: "0.5%", fontSize: "12px" }}>
                    <div className="col-2"><b>{t('registeredHospitals.id')}</b></div>
                    <div className="col-3"><b>{t('registeredHospitals.clinic')}</b></div>
                    {/* {selected === "approved" && <div className="col-1"><b>{t('registeredHospitals.patients')}</b></div>} */}

                    <div className="col-3"><b>{t('registeredHospitals.type')}</b></div>
                    <div className="col-2"><b>{t('registeredHospitals.date')}</b></div>
                    <div className="col-2"><b>{t('registeredHospitals.location')}</b></div>
                  </div>
                  {display}
                </> : (
                  <div style={{ color: "", fontSize: "20px", height: "200px", padding: "10%" }}>
                    {!loading ? <h5>{selected === "approved" ? t('registeredHospitals.noMoreApproved') : selected === "pending" ? t('registeredHospitals.noMorePending') : selected === "rejected" ? t('registeredHospitals.noMoreRejected') : t('registeredHospitals.noMoreExpired')}</h5> : ""}
                  </div>
                )}
              </div>

            </div>
          </div>

          {totalPages > 1 ?
            <div className="pagn pagn-small">
              <br />
              <br />
              <br />
              <Pagination
                activePage={currentPage}
                itemsCountPerPage={perPage}
                totalItemsCount={total}
                pageRangeDisplayed={totalPages}
                onChange={handlePageChange}
                disabledClass="disabled-class"
              />
            </div>
            : null}

        </div>
      </div>

    </div>
  )
}

export default RegisteredHospitals
